const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 1,
        draggable: false,
    },
    tablet: {
        breakpoint: { max: 1023, min: 640 },
        items: 1,
        draggable: true,
    },
    mobile: {
        breakpoint: { max: 639, min: 0 },
        items: 1,
        draggable: true,
    },
};

export const sliderParams = {
    additionalTransform: 0,
    arrows: false,
    centerMode: false,
    className: '',
    slidesToSlide: 1,
    dotListClass: '',
    focusOnSelect: false,
    infinite: true,
    keyBoardControl: false,
    itemClass: '',
    minimumTouchDrag: 80,
    renderButtonGroupOutside: true,
    renderDotsOutside: false,
    responsive: responsive,
    showDots: false,
    sliderClass: '',
    autoPlay: true,
    autoPlaySpeed: 8000
};
